import { useSyncExternalStore } from 'react';

import type { PillState } from './engine';
import { floorNet } from './floorNet';

import './status-pill.css';

/**
 * The connection status pill (netShim's #jjbnetpill as a component): green
 * "went through", blue busy spinner while saving, amber when actions are being
 * held for signal or an earlier action is being checked, red when an earlier
 * action may not have finished. Hidden entirely when there is nothing to say.
 */
export function StatusPill(): JSX.Element | null {
  const pill = useSyncExternalStore<PillState | null>(
    (onChange) => floorNet.subscribe(onChange),
    () => floorNet.pill()
  );

  if (pill === null) {
    return null;
  }
  return (
    <div className={`net-pill net-pill--${pill.kind}`} role="status">
      {pill.kind === 'busy' ? <span className="net-pill__spin" /> : null}
      {pill.text}
    </div>
  );
}
